import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { fetchCostRates } from '../services/cost-rates.service';

/**
 * The rates the stepper prices options with, the content rate matched on how many fields are
 * picked. They move slowly, so a few minutes' cache is fine; the previous answer stays on screen
 * while a new field count loads. `enabled` off (customers, who never see cost) sends no request.
 */
export function useCostRates(
  subsidiaryId: string,
  connectorCode: string,
  contentFields: number,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.costEstimates.rates(subsidiaryId, connectorCode, contentFields),
    queryFn: () => fetchCostRates(subsidiaryId, connectorCode, contentFields),
    enabled: enabled && subsidiaryId !== '' && connectorCode !== '',
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
  });
}
